import React, { Component } from 'react';

class IconEditWhite extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                fill="none"
                viewBox="0 0 24 25"
            >
                <g clipPath="url(#clip0_1794_12496)">
                    <path
                        fill="#fff"
                        d="M11.988.755A11.64 11.64 0 005.46 2.76 11.87 11.87 0 001.132 8.1a12.049 12.049 0 00-.67 6.878 11.952 11.952 0 003.215 6.095 11.702 11.702 0 006.016 3.258c2.279.46 4.64.224 6.788-.676a11.783 11.783 0 005.273-4.384 12.015 12.015 0 001.98-6.613c.001-1.563-.303-3.111-.893-4.555a11.911 11.911 0 00-2.546-3.863 11.736 11.736 0 00-3.811-2.58 11.614 11.614 0 00-4.496-.906z"
                    ></path>
                    <path
                        fill="#1D53A5"
                        d="M5.274 16.204v2.833H8.07l8.247-8.356-2.796-2.83-8.247 8.353zM18.48 8.49a.758.758 0 000-1.061l-1.744-1.773a.738.738 0 00-1.048 0L14.321 7.04l2.796 2.833L18.48 8.49z"
                    ></path>
                </g>
                <defs>
                    <clipPath id="clip0_1794_12496">
                        <path
                            fill="#fff"
                            d="M0 0H23.496V23.805H0z"
                            transform="translate(.238 .755)"
                        ></path>
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default IconEditWhite;